import { cn } from "@/libs/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

type Props = {
  img_url: string;
  alt?: string;
  name?: string;
  className?: string;
  textClassName?: string;
};

export default function CommonAvatar({
  img_url,
  alt,
  name,
  className,
  textClassName,
}: Props) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Avatar className="size-6">
        <AvatarImage src={img_url} />
        <AvatarFallback>{alt}</AvatarFallback>
      </Avatar>
      <span
        className={cn(
          "whitespace-nowrap text-xs text-gray-A font-normal",
          textClassName
        )}
      >
        {name}
      </span>
    </div>
  );
}
